import { wespeechcraftgroupSaveMobile,wespeechcraftmobile,wespeechcraftgroupUpdateMobile,wespeechcraftRemoveGroupId,
    wespeechcraftDelete,wespeechcraftGroupDelete,queryMediaId,wespeechcraftMmove,wespeechcraftgroupMoveGroup,
    wespeechcraftgroupTop,wespeechcraftgroupTopCancel} from "@/server/api.js";
import { Toast } from "vant";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
import {handleShowMore, shareListFun} from "@/utils/public";

export default {
    name: "PersonalTree",
    props: {
        // 总数据，必传
        datalist: Array,
        titleval:String,
    },
    data() {
        return {
            // 当前级组件已展开的项
            expandArr: [],
            treeList: [],
            activeNames: "",
            pageNum: 1,
            mediaid: "",
            showMore: false,
            showHeight: 50,
            expandTrue: false,
            groupDialog:false,
            addGroupName:'',//新建话术分组名
            showError:false,
            isType:'group',
            groupId:0,
            showPicker:false,
            activeIndex:'',  //话术分组当前点击index
            listIndex:'', //话术列表item的index
            groupType:'新建分组',
            currentProdureId:0,//移动当前话术分组
            list:[],//除置顶外的话术分组
            defaultIndex:0,
            showPdf: false,
            showFile: false,
            showType: '',
            preFileUrl: '',
            detailObj: {},
        };
    },
    computed:{
        resetDataList(){
            let resetTop = [];
            this.list = [];
            for (let i of this.datalist){
                if(i.topFlag ===1){
                   // console.log(i)
                    resetTop.push(i);
                }else{
                    this.list.push(i);
                }
            }
            resetTop.sort((a,b)=>{
                return new Date(b.topTime) - new Date(a.topTime);
            });
            resetTop.push(...this.list);
            return resetTop;
        }
    },
    watch:{
        titleval(val){
            this.activeNames = '';
        }
    },
    methods: {
        //点击当前分组显示三个点
        produre_group(index,e){
          e.stopPropagation();
          this.isType = 'group';
          let produreGroup = this.$refs.produreItem[index].getBoundingClientRect().top;
            this.activeIndex = index;
            this.listIndex = 999999;
          if(produreGroup > window.innerHeight - 200){
              this.$nextTick(()=>{
                  this.$refs.border[0].style.top = '33px';
              });
             //
            }else{
              this.$nextTick(()=>{
                  this.$refs.border[0].style.top = '33px';
              })
          }
        },

        //点击个人话术列表三个点
        clickProdureItem(index,e){
            e.stopPropagation();
            this.isType = 'list';
            this.activeIndex = 99999;
            this.listIndex = index;
        },

        //上移分组
        async moveToUp(index,e){
          e.stopPropagation();
          this.listIndex = this.activeIndex = 999999;
          if(this.isType==='group'){
              let list = this.resetDataList[index];
              let prev = this.resetDataList[index-1];
              this.resetDataList.splice(index,1,prev);
              this.resetDataList.splice(index-1,1,list);
              const res = await wespeechcraftgroupMoveGroup({
                  "moveDownId": prev.id,
                  "moveUpId": list.id,
                  "type": 1
              });
              if(res.code !=='200') return Toast.fail(res.msg);
              this.$notify({type:"success",message:'操作成功'});

              let scrollTop = window.scrollY;
              this.$emit('personalList',scrollTop);
          }else{
              let item = this.treeList[index];
              let prev = this.treeList[index-1];
              this.treeList.splice(index,1,prev);
              this.treeList.splice(index-1,1,item);
              const res = await wespeechcraftMmove({
                  "moveDownId": prev.id,
                  "moveUpId": item.id,
                  "type": 1
              });
              if(res.code !=='200') return Toast.fail(res.msg);
              this.$notify({type:"success",message:'操作成功'});

              let scrollTop = window.scrollY;
              this.$emit('personalList',scrollTop);
          }

        },

        //编辑话术
        async editProdureItem(val,e){
           e.stopPropagation();
           await this.$router.push({
               path:'newReply',
               query:{
                   id:val.id,
               }
            })
        },

        //分组置顶
        async resetTop(index,item,e){
            e.stopPropagation();
            this.listIndex = this.activeIndex = 999999;
            if(!item.topFlag){
                const res = await wespeechcraftgroupTop({
                    id:item.id
                });
                if(res.code !=='200') return Toast.fail(res.msg);
                this.$notify({type:"success",message:'操作成功'});

                let scrollTop = window.scrollY;
                this.$emit('personalList',scrollTop);
            }else{
                const res = await wespeechcraftgroupTopCancel({
                    id:item.id
                });
                if(res.code !=='200') return Toast.fail(res.msg);
                this.$notify({type:"success",message:'操作成功'});

                let scrollTop = window.scrollY;
                this.$emit('personalList',scrollTop);
            }
        },

        //话术列表移动至
        moveItemTo(id){
           this.currentProdureId = id;
           for(let i=0,len=this.resetDataList.length;i<len;i++){
               if(this.resetDataList[i].id ===this.activeNames){
                   this.defaultIndex = i;
               }
           }
           this.showPicker = true;
        },

        //下移分组
        async moveToBottom(index,e){
            e.stopPropagation();
            this.listIndex = this.activeIndex = 999999;
            if(this.isType === 'group'){
                let list = this.resetDataList[index];
                let next = this.resetDataList[index+1];
                this.resetDataList.splice(index,1,next);
                this.resetDataList.splice(index+1,1,list);
                const res = await wespeechcraftgroupMoveGroup({
                    "moveDownId": list.id,
                    "moveUpId": next.id,
                    "type": 1
                });
                if(res.code !=='200') return Toast.fail(res.msg);
                this.$notify({type:"success",message:'操作成功'});

                let scrollTop = window.scrollY;
                this.$emit('personalList',scrollTop);
            }else{
                let list = this.treeList[index];
                let next = this.treeList[index+1];
                this.treeList.splice(index,1,next);
                this.treeList.splice(index+1,1,list);
                const res = await wespeechcraftMmove({
                    "moveDownId": list.id,
                    "moveUpId": next.id,
                    "type": 1
                });
                if(res.code !=='200') return Toast.fail(res.msg);
                this.$notify({type:"success",message:'操作成功'});
                let scrollTop = window.scrollY;
                //
                this.$emit('personalList',scrollTop);
            }
        },

        cancelHide(){
          this.activeIndex = 999999;
          this.listIndex = 999999;
        },
        //选中分组值
        async onConfirm(val){
            console.log(val.id);
            this.listIndex = 99999;
            this.showPicker = false;
            const res = await wespeechcraftRemoveGroupId({
                ids:[this.currentProdureId],
                groupId:val.id,
            });
            if(res.code !=='200') return Toast.fail(res.msg);
            this.$notify({
                type:'success',
                message:'操作成功'
            });

            let scrollTop = window.scrollY;
            this.$emit('personalList',scrollTop);
        },
        //新建话术跳转
        addNewProdure(e){
            e.stopPropagation();
            this.$router.push('newReply');
        },

        //新建分组，重命名分组
        addNewGroup(e,val){
            this.activeIndex = 999999;
            e.stopPropagation();
            if(val){
                this.addGroupName = val.title;
                this.groupId = val.id;
                this.groupType = '重命名';
            }else{
                this.groupId = '';
                this.groupType = '新建分组';
                this.addGroupName = '';
            }
            this.showError = false;
            this.groupDialog = true;
        },
        //删除个人话术和分组
        deleteProdure(id,isType,index,e){
            e.stopPropagation();
            this.listIndex = this.activeIndex = 999999;
            this.$dialog.confirm({
                title:'提示',
                message: isType==='group'? '删除后组内的个人话术也会被删除，是否确认删除该分组？':'删除后将不可恢复，是否确认删除该话术？',
                messageAlign:'left',
                showCancelButton:true,
                confirmButtonColor:'#277FFF'
            }).then(async()=>{
                if(isType==='group'){
                   // console.log(id)
                    const res = await wespeechcraftGroupDelete({id:id});
                    if(res.code !=='200') return Toast.fail(res.msg);
                    //
                    this.$notify({
                        type:'success',
                        message:'操作成功'
                    });
                    this.resetDataList.splice(index,1);
                    let scrollTop = window.scrollY;
                    this.$emit('personalList',scrollTop);
                }else if(isType==='list'){
                    console.log(id)
                    const res  = await wespeechcraftDelete({id:id});
                    if(res.code !=='200') return Toast.fail(res.msg);
                    //
                    this.$notify({
                        type:'success',
                        message:'操作成功'
                    });
                    this.treeList.splice(index,1);
                    let scrollTop = window.scrollY;
                    this.$emit('personalList',scrollTop);
                }
                //传入分组id删除
            }).catch((err)=>{
                console.log(err)
            })
        },

        beforeClose(action,done){
            if(action==='confirm'){
                done(false);
            }else{
                done();
            }
        },
        //创建分组确认
        async addNewGroupConfirm(){
            if(this.addGroupName){
                this.groupDialog = false;
                this.showError = false;
                if(this.groupId){
                    const res = await wespeechcraftgroupUpdateMobile({title:this.addGroupName,type:1,id:this.groupId});
                    if(res.code !=='200') return Toast.fail(res.msg);
                    this.$notify({
                        type:"success",
                        message:'操作成功'
                    });

                    let scrollTop = window.scrollY;
                    this.$emit('personalList',scrollTop);
                }else{
                    const res = await wespeechcraftgroupSaveMobile({title:this.addGroupName,type:1});
                    if(res.code !=='200') return Toast.fail(res.msg);
                    Toast.success('操作成功');
                    this.$notify({
                        type:"success",
                        message:'操作成功'
                    });

                    let scrollTop = window.scrollY;
                    this.$emit('personalList',scrollTop);
                }
            }else{
                this.showError = true;
            }
        },

        addNewGroupCancel(){
            this.groupDialog = false;
        },

        // 展开
        async expandItem(id) {
            this.treeList = [];
            if(this.activeNames==id){
                this.activeNames = '';
                return false;
            }
            this.activeNames = id;
            // console.log('fff',name)
            if (id) {
                this.$nextTick(async()=>{
                    const res = await wespeechcraftmobile({
                        groupId: id,
                        pageSize: 1000,
                        type:1,
                        title:this.titleval
                    });
                    this.treeList = res.data.t;
                    this.treeList.map((v) => {
                        if (v.listAtt.length > 3) {
                            this.expandTrue = false;
                            v.listtotal = v.listAtt.length;
                            v.newlistArr = v.listAtt.slice(0, 3);
                        } else {
                            v.newlistArr = v.listAtt;
                        }
                    });
                    this.isShowExpand();
                });

            }
        },
        isShowExpand() {
            this.$nextTick(() => {
                let hideText = document.querySelectorAll(".textMsgType>p");
                for (let i of hideText) {
                   // console.log(i.offsetHeight);
                    if (i.offsetHeight > 89) {
                        i.nextElementSibling.style.display = "block";
                        i.classList.add("hide-text");
                    }
                }
            });
        },
        fahterexpandItem(val) {
            this.expandItem(this.activeNames, val);
        },
        //查看更多
        lookMore(obj) {
            this.expandTrue = true;
            obj.newlistArr = obj.listAtt;
            this.$forceUpdate();
        },
        closeList(obj) {
            this.expandTrue = false;
            obj.newlistArr = obj.newlistArr.slice(0, 3);
            this.$forceUpdate();
        },
        async getMediaId(id) {
            const res = await queryMediaId({ id: id });
            if (res.code !== "200") return Toast.fail(res.msg);
            this.mediaid = { mediaid: res.data };
        },
        //点击展开更多
        handleShowMoreClick(){
            return handleShowMore;
        },
        //分享话术列表
        async shareList(obj){
            await shareListFun(obj)
        },
        // 预览
        previewFile(e, obj) {
            e.stopPropagation();
            this.detailObj = obj
            this.showType = obj.msgType;
            this[obj.msgType =='file'?'showPdf':'showFile'] = true
            this.preFileUrl = obj.url;
            if(obj.msgType === 'file' ){
                this.$nextTick(() => {
                    this.pdfh5 = new Pdfh5("#pdf-detail", {
                        pdfurl: obj.url,
                        maxZoom: 3,
                        lazy: true,
                        scrollEnable: true,
                    });
                });
            }
        },
        closePopup() {
            this.showPdf = false;
            this.detailObj = {};
        },
        closeImg() {
            this.showFile = false;
            this.preFileUrl = '';
            this.detailObj = {};
        },
    },
};
